import userEdit from '@/components/pages/main-pages/user-management/user-edit/user-edit.vue'
import { mapActions, mapGetters } from 'vuex'
import { roleMapper } from '@/helpers/users.js'
import { formatDate } from '@/helpers/date.js'
export default {
  components: {
    userEdit
  },
  data() {
    return {
      columns: ['name', 'email', 'displayRole', 'status', 'lastLoggedIn', 'edit'],
      options: {
        filterable: false,
        headings: {
          name: 'Name',
          email: 'E-mail',
          displayRole: 'Role',
          status: 'Status',
          lastLoggedIn: 'last logged in',
          edit: ' '
        },
        perPageValues: [10],
        orderBy: {
          column: 'name'
        },
        childRow: userEdit
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isSuperAdmin']),
    tables: function () {
      return {
        users: {
          title: 'Production User List',
          ref: 'userTable',
          options: Object.assign({}, this.options, {
            requestFunction: this.getUsers,
            responseAdapter: function (resp) {
              var data = this.getResponseData(resp)
              return {
                data: data.data
                  .map((user) => {
                    return {
                      name: user.name,
                      email: user.email,
                      role: user.role,
                      displayRole: roleMapper(user.role),
                      status: user.status,
                      lastLoggedIn: formatDate(user.last_logged_at, 'DD.MM.YYYY H:mm'),
                      id: user.id,
                      edit: this.toggleChildRow,
                      refresh: this.refresh,
                      ref: 'userTable'
                    }
                  })
                  .filter((user) => user.status !== 'deleted'),
                count: data.total
              }
            }
          })
        },
        legals: {
          title: 'Legal Reps list',
          ref: 'legalTable',
          options: Object.assign({}, this.options, {
            requestFunction: function (data) {
              return this.getUsers(Object.assign({}, data, { role: '[legal]' }))
            }.bind(this),
            responseAdapter: function (resp) {
              var data = this.getResponseData(resp)
              return {
                data: data.data
                  .map((user) => {
                    return {
                      name: user.name,
                      email: user.email,
                      role: roleMapper(user.role),
                      status: user.status,
                      id: user.id,
                      edit: this.toggleChildRow,
                      refresh: this.refresh,
                      ref: 'legalTable'
                    }
                  })
                  .filter((user) => user.status !== 'deleted'),
                count: data.total
              }
            }
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['getUsers']),
    toggleEditRow: function (id, ref) {
      this.$refs[ref][0].toggleChildRow(id)
    },
    showEditUserButton: function (role) {
      if (this.isSuperAdmin) return true
      if (role === 'superadmin') return false
      return true
    },
    transformList: function (list, ref) {
      return list
        .map((user) => {
          return {
            name: user.name,
            email: user.email,
            displayRole: roleMapper(user.role),
            status: user.status,
            id: user.id,
            edit: this.toggleEditRow,
            ref
          }
        })
        .filter((user) => user.status !== 'deleted')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/user-management/user-list/user-list.js